module.exports = __webpack_public_path__ + "img/mailchimp-logo.6c40a909.png";